import css from 'styled-jsx/css';

const style = css`
  .fuel-transaction-map {
    height: 300px;
    margin: 24px;
  }
  .fuel-transaction-map-locations {
    padding: 0 24px 100px;
  }
  .fuel-transaction-map-marker {
    display: flex;
    align-items: flex-start;
  }
  .fuel-transaction-map-label {
    margin-left: 4px;
    padding: 2px 6px;
    border-radius: 4px;
    background: white;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
    font-size: 12px;
    white-space: nowrap;
  }
`;

export default style;
